/**
 * qualification.js — single source of truth for the SWOT / Decision-Matrix verdict.
 * Mirrors the formula used inside QualificationSWOT.jsx so the chip on the
 * Enquiry list/Kanban and the in-page matrix always agree.
 */

const DECISION_PARAMS = [
  { k: 'technical_fit',         weight: 15 },
  { k: 'financial_feasibility', weight: 15 },
  { k: 'past_experience',       weight: 10 },
  { k: 'competition',           weight: 10 },
  { k: 'resource_availability', weight: 10 },
  { k: 'execution_risk',        weight: 15 },
  { k: 'cashflow_requirement',  weight: 10 },
  { k: 'strategic',             weight: 10 },
  { k: 'client_relationship',   weight:  5 },
];

/** Returns { score: 0-100, verdict: 'GO' | 'CONDITIONAL GO' | 'NO-GO' | null, paramsScored }. */
export function computeQualificationVerdict(qualification) {
  if (!qualification) return { score: 0, verdict: null, paramsScored: 0 };
  const dm = qualification.decision_matrix || {};
  let paramsScored = 0;
  const weightedTotal = DECISION_PARAMS.reduce((sum, p) => {
    const s = Number(dm[p.k]?.score) || 0;
    if (s > 0) paramsScored += 1;
    return sum + (s * p.weight);
  }, 0);
  // Same normalisation as QualificationSWOT.jsx — divide by 5 so a perfect 5 across
  // all params yields exactly 100 (weights already sum to 100; max weighted = 500).
  const score = weightedTotal / 5;
  const verdict = paramsScored === 0 ? null
                : score >= 75       ? 'GO'
                : score >= 50       ? 'CONDITIONAL GO'
                                    : 'NO-GO';
  return { score, verdict, paramsScored };
}

/** Tailwind classes for the verdict chip. */
export function verdictChipClass(verdict) {
  if (verdict === 'GO') return 'bg-emerald-600 text-white border-emerald-700';
  if (verdict === 'CONDITIONAL GO') return 'bg-amber-500 text-white border-amber-600';
  if (verdict === 'NO-GO') return 'bg-rose-600 text-white border-rose-700';
  return 'bg-slate-200 text-slate-600 border-slate-300';
}
